import React, { useState, useEffect } from 'react';
import { IoIosArrowUp } from "react-icons/io";


const GoTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const toggleVisibility = () => {
    if (window.pageYOffset > 0) {
      setIsVisible(true);
      // Calculate scroll progress (0 to 360deg)
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.pageYOffset / scrollHeight) * 360;
      setScrollProgress(progress);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div id="Top">
      <button 
        id="goTop" 
        className={isVisible ? 'show' : ''}
        onClick={scrollToTop}
        aria-label="Go to top"
      >
        <span 
          className="border-progress" 
          style={{ '--progress-angle': `${scrollProgress}deg` }}
        ></span>
        <span className="icon">
          <IoIosArrowUp />
        </span>
      </button>
    </div>
  );
};

export default GoTop;